import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import store from './store';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

function renderApp() {
  const appRoot = ReactDOM.createRoot(document.getElementById('root'));
  appRoot.render(
    // <React.StrictMode>
      <Provider store={store}>
        <HelmetProvider debug>
          <App />
        </HelmetProvider>
      </Provider>
    // </React.StrictMode>
  );
  reportWebVitals();
}

/**
 * Load runtime config from /config.json before rendering the app.
 * This file lives in public/ and is NOT compiled into the bundle,
 * so installers can edit it after deployment to customise the site
 * without needing the source code.
 */
fetch('/config.json')
  .then(res => res.json())
  .then(config => {
    // Make config globally available to all components
    window.__HYMNFORGE_CONFIG__ = config;

    // Apply colour theme as CSS custom properties on the root element.
    // Components reference these via var(--color-...) in styles.css / song_lyrics.scss.
    const root = document.documentElement;
    if (config.colors) {
      root.style.setProperty('--color-accent',         config.colors.accent_color   || '#007bff');
      root.style.setProperty('--color-background',     config.colors.background     || '#ffffff');
      root.style.setProperty('--color-text',           config.colors.text           || '#333333');
      root.style.setProperty('--color-text-muted',     config.colors.text_muted     || '#666666');
      root.style.setProperty('--color-border',         config.colors.border         || '#444444');
      root.style.setProperty('--color-list-item-alt',  config.colors.list_item_alt  || '#eeeeee');
      root.style.setProperty('--color-song-numbers',   config.colors.song_numbers   || '#333333');
      root.style.setProperty('--color-buttons',        config.colors.buttons        || '#555555');
      root.style.setProperty('--color-chord',          config.colors.chord_color    || '#1f45ff');
    }

    // Set the browser tab title immediately (Helmet updates it per-page)
    document.title = config.site_name || 'HymnForge';

    renderApp();
  })
  .catch(err => {
    // If config.json is missing or malformed, fall back to defaults and still render
    console.warn('HymnForge: could not load config.json, using defaults.', err);
    window.__HYMNFORGE_CONFIG__ = {};
    renderApp();
  });
